import Image from "next/image";
import {P} from "@/components/ui/P";
import {Htag} from "@/components/ui/htag";
import CaruselService from "@/components/ui/carusel";
import {CarouselItem} from "@/components/ui/carousel";

const team = [
    {
        name: "Ирина Петрова",
        role: "Руководитель агентства",
        image: "/team/irina.jpg",
        description: "20 лет опыта в недвижимости Мурманска. Специализация — сложные сделки.",
    },
    {
        name: "Александр Сидоров",
        role: "Юрист",
        image: "/team/alexander.jpg",
        description: "Проверка документов, сопровождение сделок, защита интересов клиента.",
    },
    {
        name: "Мария Кузнецова",
        role: "Агент по продажам",
        image: "/team/maria.jpg",
        description: "Поможет быстро продать или купить квартиру на лучших условиях.",
    },
];

export default function Team() {
    return (
        <section className="py-12" id="team">
            <div className="max-w-7xl mb-6 mx-3 lg:mx-0 ">
                <P size={'l'}>Наша команда</P>
                <P className="">Люди, которые сделают ваш путь в недвижимости комфортным и безопасным</P>
            </div>

            <div className="hidden lg:grid gap-8 grid-cols-3 ">
                {team.map((member, index) => (
                    <div key={index}
                         className="bg-gradient-to-br from-green-100 via-white to-green-50 rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300">
                        <div className="relative h-60 w-full">
                            <Image
                                src={member.image}
                                alt={member.name}
                                layout="fill"
                                objectFit="cover"
                                className="rounded-t-2xl"
                            />
                        </div>
                        <div className="p-5 text-left">
                            <h3 className="text-xl font-semibold text-gray-900">{member.name}</h3>
                            <p className="text-sm text-primary font-medium mb-2">{member.role}</p>
                            <p className="text-gray-600 text-sm">{member.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className={'block lg:hidden'}>
                <CaruselService>
                    {team.map((member, index) => (
                        <CarouselItem key={index}>
                            <div
                                 className="bg-gradient-to-br from-green-100 via-white to-green-50 rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300">
                                <div className="relative h-60 w-full">
                                    <Image
                                        src={member.image}
                                        alt={member.name}
                                        layout="fill"
                                        objectFit="cover"
                                        className="rounded-t-2xl"
                                    />
                                </div>
                                <div className="p-5 text-left">
                                    <h3 className="text-xl font-semibold text-gray-900">{member.name}</h3>
                                    <p className="text-sm text-primary font-medium mb-2">{member.role}</p>
                                    <p className="text-gray-600 text-sm">{member.description}</p>
                                </div>
                            </div>
                        </CarouselItem>
                    ))}
                </CaruselService>
            </div>
        </section>
    );
}
